import { api } from '../api';
export default {
  sms:               (body) => api.post('/v1/outbound/sms',               body).then(r => r.data),
  whatsapp:          (body) => api.post('/v1/outbound/whatsapp',          body).then(r => r.data),
  email:             (body) => api.post('/v1/outbound/email',             body).then(r => r.data),
  voiceCampaign:     (body) => api.post('/v1/outbound/voice/campaign',    body).then(r => r.data),
  voiceServiceJourney: (body) => api.post('/v1/outbound/voice/service-journey', body).then(r => r.data),
};
